import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle, FlaskConical, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = 'fne_env_banner_dismissed_at';

/**
 * Banner global affichant l'état FNE quand on est en environnement DEV (non-mock)
 * pour éviter de croire qu'on travaille en PROD pendant les tests Sprint 5.
 *
 * Visible sur toutes les pages admin (placé dans AdminLayout).
 */
const FneEnvBanner = () => {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/fne/balance`)
      .then((r) => setInfo(r.data))
      .catch(() => setInfo(null));
  }, []);

  useEffect(() => {
    const ts = localStorage.getItem(STORAGE_KEY);
    if (!ts) return;
    // Réafficher la bannière après 24h
    if (Date.now() - Number(ts) > 24 * 60 * 60 * 1000) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      setDismissed(true);
    }
  }, []);

  if (!info || dismissed) return null;
  const env = (info.environment || '').toLowerCase();
  const isMock = !!info.mockMode;
  if (env === 'prod' && !isMock) return null; // PROD réel : pas de banner (sera ajouté plus tard si besoin)

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setDismissed(true);
  };

  const label = isMock
    ? '🟢 FNE MOCK MODE — aucune certification réelle envoyée à la DGI'
    : '🟡 FNE DEV MODE — toutes les certifications sont des TESTS sur l’environnement DGI de développement';
  const subLabel = isMock
    ? 'Les réponses FNE sont simulées. Pour passer en réel, désactivez mockMode dans Settings → FNE.'
    : `Solde stickers : ${info.balance ?? '?'} / Seuil : ${info.threshold ?? '?'} — n’utilisez PAS de vraies factures clients.`;

  return (
    <div
      data-testid="fne-env-banner"
      className={`w-full ${isMock ? 'bg-emerald-50 border-emerald-300 text-emerald-900' : 'bg-amber-50 border-amber-300 text-amber-900'} border-b px-4 py-2 flex items-start gap-3`}
    >
      {isMock ? (
        <FlaskConical className="w-4 h-4 mt-0.5 shrink-0" />
      ) : (
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <div className="text-xs font-semibold">{label}</div>
        <div className="text-[11px] opacity-80">{subLabel}</div>
      </div>
      <button
        onClick={dismiss}
        className="text-xs opacity-60 hover:opacity-100"
        title="Masquer pour 24h"
        data-testid="fne-env-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default FneEnvBanner;
